import moment from 'moment'

export function date(val, format = 'YYYY-MM-DD HH:mm:ss', def = '--') {
    if (val) return moment(val).format(format)
    if (def) return def
    return val
}



// WEBPACK FOOTER //
// ./src/filters/index.js